import React, { Component } from 'react';
import {Pagination} from "react-bootstrap";
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Form from './components/Form';
import Table from './components/Table';
import API from '../../services/API';
import { PAGE_LIMIT } from "./config";
import { handleFieldChange } from "../../Utils";
import Switch from "react-toggle-switch";

class BidderCtrHourly extends Component {
    constructor() {
        super();

        this.state = {
            sources: [],
            affids: [],
            usedAffids: [],
            params: [],
            paramsObj: {},
            report: [],
            total: {},
            sortParam: null,
            sortOrder: 1,
            pagesTotal: 0,
            activePage: 1,
            type: 'hourly',
            isLoading: false
        };

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.handlePageSelect = this.handlePageSelect.bind(this);
        this.handleTypeChange = this.handleTypeChange.bind(this);
    }

    componentDidMount() {
        Promise.all([
            API.BidderSources.getAvailableSources(),
            API.BidderCtrHourly.getAffids(),
            API.BidderCtrHourly.getUsedAffids(),
        ])
            .then(([ sources, { affids }, { usedAffids } ]) => this.setState({ sources, affids, usedAffids }));
    }

    componentWillUpdate(nextProps, nextState) {
        const { report, sortParam, sortOrder } = nextState;

        if(this.state.sortParam != sortParam || this.state.sortOrder != sortOrder) {
            this.sortReport(report, sortParam, sortOrder);

            this.setState({ report, activePage: 1 });
        }
    }

    sortReport(report, sortParam, sortOrder) {
        const paramIndex = this.state.paramsObj[sortParam];
        report.sort((objA, objB) => {
            let valueA = objA[paramIndex] ? objA[paramIndex] : 0;
            let valueB = objB[paramIndex] ? objB[paramIndex] : 0;

            if(sortParam === 'affid') {
                valueA = this.state.affids[valueA];
                valueB = this.state.affids[valueB];
            }



            if(valueA > valueB) return 1 * sortOrder;
            else if(valueA < valueB) return -1 * sortOrder;

            return 0;
        });
    }

    handleSubmit(filters) {
        this.setState({ isLoading: true });

        this.loadReport(filters);
    }

    loadReport(filters) {
        API.BidderCtrHourly.get(this.state.type, filters)
            .then(({ params, report, total }) => {
                const pagesTotal = Math.ceil(report.length / PAGE_LIMIT);
                const paramsObj = params.reduce((obj, param, index) => {
                    obj[param] = index;

                    return obj;
                }, {});

                this.setState({ params, paramsObj, report, total, activePage: 1, pagesTotal, isLoading: false })
            });
    }

    handleSort(param) {
        const { sortParam, sortOrder } = this.state;

        if(sortParam === null) this.setState({ sortParam: param });
        else if(param === sortParam) this.setState({ sortOrder: sortOrder * -1 });
        else this.setState({ sortParam: param, sortOrder: 1 });
    }

    handlePageSelect(activePage) {
        this.setState({ activePage });
    }

    handleTypeChange() {
        this.setState(prevState =>
            ({ type: prevState.type === 'hourly' ? 'daily' : 'hourly' }));
    }


    getTable() {
        let { params, paramsObj, report, total, activePage } = this.state;

        if(report.length) {
            const pageStart = ( activePage - 1 ) * PAGE_LIMIT;
            const pageEnd = activePage * PAGE_LIMIT;
            report = report.slice(pageStart, pageEnd);

            return <Table params={params} paramsObj={paramsObj} report={report} total={total} onSortChange={this.handleSort}/>;
        }

        return <p>No Data</p>
    }

    render() {
        const { isLoading, sources, affids, usedAffids } = this.state;

        return (
            <Container loading={isLoading}>
                <Heading title="Bidder CTR Hourly"/>
                <div style={{ marginBottom: '15px' }}>
                    <span>Hourly </span>
                    <Switch onClick={this.handleTypeChange} on={this.state.type === 'daily'} />
                    <span> Daily</span>
                </div>
                <Form onSubmit={this.handleSubmit} sources={sources} affids={affids} usedAffids={usedAffids} type={this.state.type}/>

                {this.getTable()}

                <Pagination
                    items={this.state.pagesTotal}
                    maxButtons={20}
                    onSelect={this.handlePageSelect}
                    activePage={this.state.activePage}
                />
            </Container>
        );
    }
}

export default BidderCtrHourly;



// WEBPACK FOOTER //
// ./src/scenes/BidderCtrHourly/index.js